<template>
  <div id="app1">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
      sessionStorage.removeItem('store');
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.el-form--inline .el-form-item
  width aotu !important
.el-form--inline .el-form-item__content
  width 200px
*
  margin 0
  padding 0
html, body
  width 100%
  height 100%
#app1
  width 100%
  height 100%
  // 滚动条的宽度
  ::-webkit-scrollbar
    width 6px // 横向滚动条
    height 15px // 纵向滚动条 必写
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb
    background-color #99a9bf
    border-radius 3px
    width 8px
  // 滚动条的宽度
  /deep/ .el-table__body-wrapper::-webkit-scrollbar
    width 6px // 横向滚动条
    height 12px // 纵向滚动条 必写
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb
    background-color #99a9bf
    border-radius 3px
// 全局设置
col[name='gutter']
  display none
body .el-table colgroup.gutter 
    display table-cell !important;
</style>



// WEBPACK FOOTER //
// src/App.vue